import AnimatedButton from './AnimatedButton';
export default AnimatedButton;